import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core'
import { ParagraphsFragment, ParagraphsLayoutEnum } from '@app-graphql/schema'

@Component({
    selector: 'app-paragraphs',
    templateUrl: './paragraphs.component.html',
    styleUrls: ['./paragraphs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ParagraphsComponent {

    @Input()
    public paragraphs: ParagraphsFragment
    protected readonly ParagraphsLayoutEnum = ParagraphsLayoutEnum
}
